/**
 * Extracts a server-relative or absolute URL from FileUpload responses.
 * Collection sample has an empty body; this handles common envelope shapes.
 */
import type { FileUploadResponseBody } from './fileUploadTypes';

const pickString = (value: unknown): string | undefined => {
  if (typeof value === 'string' && value.trim()) return value.trim();
  return undefined;
};

const fromRecord = (record: Record<string, unknown>): string | undefined =>
  pickString(record.fileUrl) ??
  pickString(record.url) ??
  pickString(record.path) ??
  pickString(record.filePath) ??
  pickString(record.relativePath);

export const extractUploadedFileUrl = (
  body: FileUploadResponseBody | undefined,
): string | undefined => {
  if (!body) return undefined;

  const direct =
    pickString(body.fileUrl) ??
    pickString(body.url) ??
    pickString(body.path);
  if (direct) return direct;

  const data = body.data;
  if (typeof data === 'string') return data;
  if (Array.isArray(data)) {
    for (const item of data) {
      if (typeof item === 'string') return item;
      if (item && typeof item === 'object') {
        const url = fromRecord(item as Record<string, unknown>);
        if (url) return url;
      }
    }
  }
  if (data && typeof data === 'object') {
    return fromRecord(data as Record<string, unknown>);
  }

  return undefined;
};
